import type React from 'react';
import classNames from 'classnames';
import Translation from '../../../general/Translation/Translation';
import { useWithSiteUrl } from '../../../general/WebshopContext/WebshopContext';
import Icon from '../../../../stories/Atoms/Icon/Icon';

interface ContinueShoppingProps {
    showOnMobile: boolean;
}

const ContinueShopping: React.FC<ContinueShoppingProps> = ({ showOnMobile }) => {
    const withSiteUrl = useWithSiteUrl();
    return (
        <div className={classNames(['mb-4'], { 'hide-xs': !showOnMobile })}>
            <a href={withSiteUrl('')} className='button button--link button--has-icon' data-testid="continue-link">
                <Icon name='fa-arrow-left-long' />
                <span><Translation pageString="checkout" stringId="continue-shopping" /></span>
            </a>
        </div>
    );
};

export default ContinueShopping;
